import React from 'react';

interface PaginationRangeArgs {
  from?: number | null;
  page: number;
  perPage?: number | null;
  total: number;
  currentCount: number;
}

interface TablePaginationFooterProps {
  info?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  testId?: string;
}

export function getPaginationRange({
  from,
  page,
  perPage,
  total,
  currentCount,
}: PaginationRangeArgs) {
  if (total <= 0 || currentCount <= 0) {
    return { start: 0, end: 0 };
  }

  const safePerPage = perPage && perPage > 0 ? perPage : currentCount;
  const start = from && from > 0 ? from : ((page - 1) * safePerPage) + 1;
  const end = Math.min(start + currentCount - 1, total);

  return { start, end };
}

const TablePaginationFooter = ({
  info,
  children,
  className = '',
  testId = 'table-pagination-footer',
}: TablePaginationFooterProps) => {
  const footerClassName = ['ntcog-table-pagination', className].filter(Boolean).join(' ');

  return (
    <div className={footerClassName} data-testid={testId}>
      {info ? (
        <div className="ntcog-table-pagination__info" data-testid={`${testId}-info`}>
          {info}
        </div>
      ) : null}
      {children ? (
        <div className="ntcog-table-pagination__controls" data-testid={`${testId}-controls-wrap`}>
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default TablePaginationFooter;
